import React from 'react';

export interface SignMin1IconProps {}

export const SignMin1Icon: React.FC<SignMin1IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.32593 3.28925L15.2944 3.97936C15.5697 4.00054 15.7758 4.24091 15.7546 4.51624C15.7408 4.69457 15.6329 4.85199 15.4715 4.92907L11.8024 6.68125L15.0962 9.97485C16.2716 11.1503 16.9504 12.7296 16.9974 14.3866L17 14.571V21H14V14.571C14 13.6944 13.6711 12.8516 13.0816 12.2077L12.9748 12.0962L9.69393 8.81525L7.96575 12.4348C7.84674 12.684 7.54826 12.7896 7.29908 12.6705C7.13769 12.5935 7.02976 12.4361 7.01604 12.2577L6.32593 3.28925Z"
        fill="#192033"
      />
    </svg>
  );
};
